import AppleButton from './appleButton.vue'
export default AppleButton
